import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useEditedQuestionIndicator, useErrorQuestionIndicator } from "../../../../_shared/hooks";
import { MailTemplateItem } from "../_shared/mail-template-item";

import type { BasicCustomMailSettingFormData } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<BasicCustomMailSettingFormData>;
};

export const ForShopping = ({ form }: Props) => {
	const {
		watch,
		setValue,
		formState: { errors },
	} = form;

	const shoppingValue = watch("forShopping.atCreated.text");

	// 値が入っているかどうかを監視（設定した項目がある場合に青丸を表示）
	useEditedQuestionIndicator("宿泊券購入時", Boolean(shoppingValue));

	// バリデーションエラーがある場合に赤丸を表示
	useErrorQuestionIndicator("宿泊券購入時", Boolean(errors.forShopping?.atCreated?.text));

	return (
		<div className="space-y-6">
			<div className="ml-2">
				{/* 宿泊券購入時 */}
				<MailTemplateItem
					hidePreviewButton={true}
					label={"宿泊券購入時"}
					dialogTitle={"宿泊券購入時"}
					value={shoppingValue || ""}
					errorMessage={errors.forShopping?.atCreated?.text?.message || ""}
					handleChange={(value) =>
						setValue(
							"forShopping.atCreated.text", //
							value,
							{ shouldDirty: true, shouldValidate: true },
						)
					}
					sendTestEmail={() => Promise.resolve()}
					lang={LangCode.Default}
					hotelEmailAddress=""
				/>
			</div>
		</div>
	);
};
